module.exports = "images/doc-service-add.455f9450a72bc867cb71a797053e5117.png";